<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button text="" (click)="back()"></ion-back-button>
    </ion-buttons>
    <ion-title *ngIf="isNew">Neue Adresse</ion-title>
    <ion-title *ngIf="!isNew">{{crm?.description}}</ion-title>
    <ion-buttons slot="end" *ngIf="platform.is('capacitor')">
      <ion-button slot="icon-only" style="box-shadow: none;" (click)="openQrCode()">
        <ion-icon name="fa-qr-code"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <h1 *ngIf="isNew">Neue Adresse</h1>
  <h1 *ngIf="!isNew">{{crm?.description}}</h1>
  <h2>Allgemein</h2>

  <div *ngIf="generalSrv.serverVersionGreaterThan('1.11.0') && generalSrv.webConfig?.hasManagerConnection">
    <h3>Art</h3>
    <div class="filter-bttn" (click)="selectArt($event)">
      <div class="fiter-bttn-content">
        <ion-icon [name]="selectedAddressArt?.icon"></ion-icon>
        {{selectedAddressArt?.description}}
      </div>
      <ion-icon name="fa-caret-down"></ion-icon>
    </div>
  </div>

  <div *ngIf="generalSrv.serverVersionGreaterThan('1.13.1') && generalSrv.webConfig?.hasManagerConnection">
    <h3>Kennung</h3>
    <div class="filter-bttn" (click)="selectIdentifier($event)">
      @if(crm.addressIdentifierName){
        <div class="fiter-bttn-content">
          {{crm?.addressIdentifierName}}
        </div>
      }@else {
        <div class="no-content">Klicken zum Auswählen...</div>
      }
      <ion-icon name="fa-caret-down"></ion-icon>
    </div>
  </div>

  <h3>Firmenname (*)</h3>
  <input type="text" placeholder="Musterfirma GmbH..." [(ngModel)]="crm.companyOne">

  <h3>Anrede</h3>
  <input type="text" placeholder="Frau..." [(ngModel)]="crm.salutation">

  <h3>Vorname</h3>
  <input type="text" placeholder="Max..." [(ngModel)]="crm.firstName">

  <h3>Name</h3>
  <input type="text" placeholder="Mustermann..." [(ngModel)]="crm.lastName">

  <h3>Straße</h3>
  <input type="text" placeholder="Musterstraße..." [(ngModel)]="crm.street">

  <h3>Plz</h3>
  <input type="text" placeholder="36251..." [(ngModel)]="crm.plz">

  <h3>Ort</h3>
  <input type="text" placeholder="Musterstadt..." [(ngModel)]="crm.town">

  <h3>Land</h3>
  <input type="text" placeholder="Deutschland..." [(ngModel)]="crm.country">
  
  <h2>Kommunikation</h2>

  <h3>Telefon</h3>
  <input type="text" placeholder="06621..." [(ngModel)]="crm.telefone">

  <h3>Telefon 2</h3>
  <input type="text" placeholder="06621..." [(ngModel)]="crm.telefoneTwo">

  <h3>Mobil</h3>
  <input type="text" placeholder="01571..." [(ngModel)]="crm.mobile">

  <h3>Telefax</h3>
  <input type="text" placeholder="0308..." [(ngModel)]="crm.telefax">

  <h3>E-Mail</h3>
  <input type="text" placeholder="test@email.com..." [(ngModel)]="crm.email">

  <h3>Website</h3>
  <input type="text" placeholder="www.afs-software.de..." [(ngModel)]="crm.website">

</ion-content>

<ion-footer>
  <ion-toolbar class="ion-padding" style="padding-top: 0;">
    <div class="button main-button" (click)="save()">Speichern</div>
  </ion-toolbar>
</ion-footer>
